// Region Country mapping based on: https://quip-amazon.com/ZTnzAHYt3HNx/SOR-Expansions-Consolidated-list-of-Currencies
export const APAC_COUNTRIES = [
    'Australia',
    'India',
    'Indonesia',
    'Japan',
    'Malaysia',
    'New Zealand',
    'Singapore',
    'South Korea',
];

export const EMEA_COUNTRIES = [
    'Austria',
    'Bahrain',
    'Belgium',
    'Czech Republic',
    'Denmark',
    'Estonia',
    'Finland',
    'France',
    'Germany',
    'Greece',
    'Ireland',
    'Israel',
    'Italy',
    'Kuwait',
    'Luxembourg',
    'Netherlands',
    'Norway',
    'Poland',
    'Portugal',
    'Romania',
    'Saudi Arabia',
    'South Africa',
    'Spain',
    'Sweden',
    'Switzerland',
    'United Arab Emirates',
    'United Kingdom',
];
